import { useEffect } from 'react';
import { Animation, Button, Modal, Text } from '@vinted/web-ui';
import useTracking from 'hooks/useTracking';
import { ClickableElement } from 'constants/tracking/clickable-elements';
import { clickEvent, viewScreenEvent } from 'libs/common/event-tracker/events';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

const PortalMergeModal = _ref => {
  let {
    banner,
    screen,
    show,
    onClose
  } = _ref;
  const {
    track
  } = useTracking();
  const {
    animationUrl,
    imageUrl,
    heading,
    text,
    textLinkTitle,
    textLinkUrl,
    primaryActionTitle,
    primaryActionUrl,
    closeActionTitle,
    closeActionUrl
  } = banner;
  useEffect(() => {
    track(viewScreenEvent({
      screen
    }));
  }, [screen, track]);

  function trackClick(target) {
    track(clickEvent({
      screen,
      target
    }));
  }

  function handleActionClick() {
    trackClick(ClickableElement.MergeAnnouncementAction);
    if (primaryActionUrl) return;
    onClose();
  }

  function handleCloseClick() {
    trackClick(ClickableElement.CloseScreen);
    if (closeActionUrl) return;
    onClose();
  }

  function handleTextClick(event) {
    if (!(event.target instanceof HTMLAnchorElement)) return;
    trackClick(ClickableElement.MergeAnnouncementLink);
  }

  let textLink = '';
  if (textLinkUrl && textLinkTitle) textLink = "<a href=\"".concat(textLinkUrl, "\">").concat(textLinkTitle, "</a>");
  return /*#__PURE__*/_jsx(Modal, {
    show: show,
    hasScrollableContent: true,
    children: /*#__PURE__*/_jsxs("div", {
      children: [/*#__PURE__*/_jsx("div", {
        className: "c-modal__image portal-merge-modal__shrinking-container",
        children: /*#__PURE__*/_jsx(Animation, {
          animationUrl: animationUrl,
          fallbackImageSrc: imageUrl,
          fallbackImageScale: Animation.ImageScaling.Contain
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "c-modal__inline-content",
        children: [/*#__PURE__*/_jsx("div", {
          className: "c-modal__title",
          children: /*#__PURE__*/_jsx(Text, {
            alignment: Text.Alignment.Center,
            text: heading,
            type: Text.Type.Heading
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "c-modal__body",
          onClick: handleTextClick,
          children: /*#__PURE__*/_jsx(Text, {
            alignment: Text.Alignment.Center,
            text: "".concat(text, " ").concat(textLink),
            html: true
          })
        })]
      }), /*#__PURE__*/_jsxs("div", {
        className: "c-modal__actions",
        children: [/*#__PURE__*/_jsx("div", {
          className: "c-modal__action",
          children: /*#__PURE__*/_jsx(Button, {
            styling: Button.Styling.Filled,
            url: primaryActionUrl,
            text: primaryActionTitle,
            onClick: handleActionClick
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "c-modal__action",
          children: /*#__PURE__*/_jsx(Button, {
            styling: Button.Styling.Flat,
            url: closeActionUrl,
            text: closeActionTitle,
            onClick: handleCloseClick
          })
        })]
      })]
    })
  });
};

export default PortalMergeModal;